import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const stockBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'directories',
    url: '/directories/stock'
  },
  {
    label: 'warehouse',
    active: true
  }
];

export type StockType = {
  name: string;
  status: string;
  guid: string;
};
